export const MaintenanceOrganization = {
  ALL: "ALL"
}



// WEBPACK FOOTER //
// ./src/enums/MaintenanceOrganization.js